module.exports = __webpack_public_path__ + "8477633b1b1fbfbf4302afd72dab34bd.png";